import styled, { css } from 'styled-components';
import { animated } from 'react-spring';
import { IconButton } from '@oneaudi/unified-web-components';
import { COLORS, SIZING } from '../../../styles/variables';
import { device } from '../../../styles/devices';

export const TextInputWrapper = styled.div<{ inputKey: string }>`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 340px;
  ${({ inputKey }) => {
    if (
      inputKey === 'firstName' ||
      inputKey === 'lastName' ||
      inputKey === 'phoneNumber' ||
      inputKey === 'tradeInVehicleModel' ||
      inputKey === 'tradeInVehicleMake' ||
      inputKey === 'tradeInVehicleYear' ||
      inputKey === 'tradeInVehicleMileage'
    ) {
      return css`
        padding-top: 24px;
        margin-top: 24px;
      `;
    }
    if (inputKey === 'tradeInVehicleVin') {
      return css`
        padding-top: 24px;
        margin-top: 24px;
        width: 304px;
      `;
    }
    return css`
      padding-top: 24px;
      margin-top: 24px;
    `;
  }}
`;

export const DeleteInputIcon = styled.button`
  padding: 0;
  background-color: inherit;
  border: none;
  position: absolute;
  right: 0;
  bottom: 6px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const InputContainer = styled.div<{ inputKey: string }>`
  position: relative;
  width: 340px;
`;
export const TextInputField = styled.input<{ $isError?: boolean }>`
  width: 100% !important;
  all: unset;
  border-bottom: ${({ $isError }) =>
    $isError ? `1px solid ${COLORS.error}` : `1px solid ${COLORS.grey80}`};
  position: relative;
  padding-top: 4px;
  padding-bottom: 8px;
  height: 24px;
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.003px;
  outline: none;
  box-sizing: unset !important;

  :-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px white inset !important;
  }
  :-moz-placeholder {
    color: transparent !important;
  }
  :-moz-placeholder:focus {
    color: #555 !important;
  }
`;

export const InputLabel = styled(animated.label)<{ $isError?: boolean }>`
  position: absolute;
  font-family: Audi Type;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.003px;
  top: 4px;
  color: ${({ $isError }) => ($isError ? COLORS.error : COLORS.grey80)};
`;

export const Note = styled.p`
  color: ${COLORS.grey60};
  font-family: Audi Type;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.002px;
  padding-top: 12px;
  /* max-width: 260px; */
`;

export const PlaceHolder = styled.div``;

export const ErrorMessage = styled.div`
  font-family: Audi Type;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.002px;
  color: ${COLORS.error};
  margin-top: 8px;
`;

export const InputContainerWithIcon = styled.div`
  display: flex;
  width: 340px;
  justify-content: space-between;
  align-items: center;
`;

export const OptionalNote = styled.span`
  font-family: Audi Type;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: ${COLORS.grey60};
  letter-spacing: 0.002px;
  margin-left: 4px;
`;

export const HelperIconWrapper = styled.div`
  height: 20px;
  width: 20px;
  margin-left: ${SIZING.unit(1)};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  .popover-styles {
    width: 300px;
    margin-top: ${SIZING.unit(0.5)};
    polygon {
      fill: ${COLORS.grey80};
    }
  }
`;

export const StyledHelperButton = styled.button`
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const Copy = styled.p`
  font-family: 'Audi Type';
  font-size: 16px;
  line-height: 24px;
  color: ${COLORS.black};
`;

export const PopoverTitle = styled.h1`
  font-family: 'Audi Type';
  font-size: 16px;
  line-height: 24px;
  color: ${COLORS.black};
  font-weight: 700;
  margin-bottom: 12px;
`;

export const Content = styled.div`
  padding: ${SIZING.unit(2)};
  width: 200px;
  position: relative;
  color: white;
  display: flex;
  flex-direction: column;
  gap: 12px;
  @media ${device.tablet} {
    width: 250px;
  }
  @media ${device.laptop} {
    width: 300px;
  }
`;

export const ButtonStyled = styled(IconButton)`
  margin: 0;
`;

export const PopoverIconWrapper = styled.div`
  position: absolute;
  width: 48px;
  top: -16px;
  right: 0;
`;
